import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function VerifyMagicLink() {
  const { loginWithMagicLink } = useAuth();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying'); // verifying | error
  const [error, setError] = useState('');
  const attempted = useRef(false);

  useEffect(() => {
    if (attempted.current) return; // avoid double-firing in React StrictMode
    attempted.current = true;

    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      setError('This link is missing its login token.');
      return;
    }

    loginWithMagicLink(token)
      .then(user => {
        navigate((user.role === 'admin' || user.role === 'super_admin') ? '/admin' : '/dashboard', { replace: true });
      })
      .catch(err => {
        setStatus('error');
        setError(err.response?.data?.error || 'This link is invalid or has expired.');
      });
  }, [searchParams, loginWithMagicLink, navigate]);

  return (
    <div style={s.page}>
      <div style={s.card}>
        {status === 'verifying' ? (
          <>
            <div style={s.spinner} />
            <div style={s.title}>Signing you in...</div>
            <div style={s.sub}>Hang tight, this only takes a second.</div>
          </>
        ) : (
          <>
            <div style={s.errorIcon}>✕</div>
            <div style={s.title}>Couldn't sign you in</div>
            <div style={s.sub}>{error}</div>
            <button onClick={() => navigate('/')} style={s.btn}>Back to login</button>
          </>
        )}
      </div>
    </div>
  );
}

const s = {
  page: { minHeight: '100vh', background: 'var(--bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 },
  card: { textAlign: 'center', maxWidth: 360 },
  spinner: { width: 32, height: 32, border: '3px solid var(--border)', borderTopColor: 'var(--pink)', borderRadius: '50%', animation: 'spin 0.8s linear infinite', margin: '0 auto 20px' },
  errorIcon: { width: 40, height: 40, borderRadius: '50%', background: 'rgba(255,68,68,0.1)', color: 'var(--red)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18, fontWeight: 800, margin: '0 auto 16px' },
  title: { fontWeight: 800, fontSize: 17, color: 'var(--text)', marginBottom: 6 },
  sub: { fontSize: 13, color: 'var(--text-secondary)', lineHeight: 1.6, marginBottom: 18 },
  btn: { padding: '10px 20px', fontSize: 13, fontWeight: 700, color: '#fff', background: 'var(--pink)', border: 'none', borderRadius: 'var(--r-md)', cursor: 'pointer', fontFamily: 'var(--font)' },
};
